import React from 'react'
import "./Title.css"

const Title = ({title}) => {
  return (
    <div className='title'>
        {title && (  <h2>{title}</h2>)}
    </div>
  )
}

export default Title


